let coralJs = document.getElementById("coral_js");
let env = coralJs.getAttribute("env"); // beta, pro

export default {
    urlPrefix: env === "local" ? "http://keiran.qq.com:8782"
        : env === "beta" ? "https://testgmall.m.qq.com" : "https://gmall.m.qq.com",
    env
};